import { createAsyncThunk } from "@reduxjs/toolkit";
import { getApi, postApi } from "../../../services/apiServices";
import {
  BULK_PRINT,
  QR_CODES_GENERATE,
  QR_CODES_LIST,
  QR_CODES_PRINT,
  EXCEL_UPLOAD,
} from "../../constants/apiConstants";
import Alertify from "../../../services/alertify";
import axios from "axios";
import { ProjectUrl } from "../../../env";
import store from "../../../redux/store";

/*---------------- QR Codes List ---------------- */
export const GetQrCodesList = createAsyncThunk(
  "get-qr-codes-list/admin",
  async (reqData) => {
    try {
      const { page, limit, search, region } = reqData;
      const response = await getApi(
        `${QR_CODES_LIST}?region=${region}&page=${page}&limit=${limit}&search=${search}`
      );
      return response;
    } catch (error) {
      console.log("Error GetQrCodesList API", error);
      Alertify.error(error.message);
      return Promise.reject(error);
    }
  }
);

/*---------------- Print QR Code ---------------- */
export const PrintQrCode = createAsyncThunk(
  "print-qr-code/admin",
  async (reqData) => {
    try {
      // Use axios directly to get a blob response
      const response = await axios({
        method: "post",
        url: `${ProjectUrl}${QR_CODES_PRINT}`,
        data: reqData,
        headers: {
          Accept: "image/png, image/jpeg, image/*",
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "69420",
          Authorization: `Bearer ${
            localStorage.getItem("token") || store.getState().auth_store.token
          }`,
        },
        responseType: "blob", // Important: This tells axios to handle the response as a blob
      });

      return response;
    } catch (error) {
      console.log("Error PrintQrCode API", error);
      Alertify.error(error.message);
      return Promise.reject(error);
    }
  }
);

/*---------------- Generate QR Code ---------------- */
export const GenerateQrCode = createAsyncThunk(
  "generate-qr-code/admin",
  async (reqData) => {
    try {
      const response = await postApi(QR_CODES_GENERATE, reqData);
      return response;
    } catch (error) {
      console.log("Error GenerateQrCode API", error);
      Alertify.error(error.message);
      return Promise.reject(error);
    }
  }
);

/*---------------- PrintBulkQrCodes---------------- */
export const PrintBulkQrCodes = createAsyncThunk(
  "bulk-print/admin",
  async (reqData) => {
    try {
      console.log("Sending bulk print request with data:", reqData);

      // Use axios directly to get a blob response
      const response = await axios({
        method: "post",
        url: `${ProjectUrl}${BULK_PRINT}`,
        data: reqData,
        headers: {
          Accept: "application/zip, application/octet-stream",
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "69420",
          Authorization: `Bearer ${
            localStorage.getItem("token") || store.getState().auth_store.token
          }`,
        },
        responseType: "blob", // Important: This tells axios to handle the response as a blob
      });

      console.log("Bulk print response received:", response);

      // Return the entire response to preserve the blob data
      return response;
    } catch (error) {
      console.error("Error in PrintBulkQrCodes API:", error);
      if (error.response) {
        console.error("Error response:", error.response);
      }
      Alertify.error(error.message || "Failed to generate QR codes");
      return Promise.reject(error);
    }
  }
);

/*---------------- Upload Excel Sheet ---------------- */
export const UploadExcelSheet = createAsyncThunk(
  "upload-excel-sheet/admin",
  async (reqData) => {
    try {
      // Create FormData object to handle file upload
      const formData = new FormData();
      formData.append("file", reqData.file);

      // Use axios directly for file upload
      const response = await axios({
        method: "post",
        url: `${ProjectUrl}${EXCEL_UPLOAD}`,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "ngrok-skip-browser-warning": "69420",
          Authorization: `Bearer ${
            localStorage.getItem("token") || store.getState().auth_store.token
          }`,
        },
      });

      return response;
    } catch (error) {
      console.error("Error UploadExcelSheet API:", error);
      Alertify.error(error.message || "Failed to upload Excel sheet");
      return Promise.reject(error);
    }
  }
);
